module.exports = __webpack_public_path__ + "media/A50.3338b924.mp3";